import {StyleSheet, Platform} from 'react-native';
import CommonStyles from '../../../utils/CommonStyles';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.overlay,
      justifyContent: 'flex-end',
      alignItems: Platform.OS === 'web' ? 'center' : undefined,
    },
    safeareaContainer: {
      backgroundColor: colors.surface,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      width: Platform.OS === 'web' ? 300 : undefined,
    },
    bottomContainer: {
      padding: 24,
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    titleInput: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 18,
      flex: 1,
      paddingVertical: 0,
    },
    noteInput: {
      fontFamily: FONTS.regularFont,
      fontSize: 16,
      marginTop: 16,
      paddingVertical: 0,
      height: 120,
      textAlignVertical: 'top',
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginTop: 32,
    },
    button: {
      flex: 1,
    },
    buttonLeft: {
      flex: 1,
      borderColor: colors.borderMuted,
    },
    buttonRight: {
      flex: 1,
      marginLeft: 21,
      borderColor: colors.borderMuted,
    },
    dateTimeContainer: {
      marginTop: 30,
      alignSelf: 'flex-start',
      width: '100%',
    },
    dateTimeView: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 16,
    },
    webContainer: {
      backgroundColor: colors.overlayLight,
      ...CommonStyles.flex_center,
    },
    detailsContainer: {
      minWidth: 375,
      ...CommonStyles.br_16,
    },
    editIconButton: {
      padding: 8,
      marginLeft: 8,
      backgroundColor: colors.accent,
      borderRadius: 8,
    },
    keyboardAccessory: {
      backgroundColor: colors.backgroundMuted,
      borderTopWidth: 1,
      borderTopColor: colors.borderMuted,
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    doneButton: {
      paddingHorizontal: 12,
      paddingVertical: 8,
    },
  });

export default makeStyles;
